import { useSelector } from "react-redux";
const ModulePermission = (module, permission) => {
  const { projectUser } = useSelector((state) => ({
    projectUser: state.projectUser.projectUser,
  }));
  const hasPermission =
    projectUser?.role?.rolePermissions.find(
      (rolePermission) =>
        rolePermission?.permission?.module.toLowerCase() ===
          module.toLowerCase() &&
        rolePermission?.permission?.permission.toLowerCase() ===
          permission.toLowerCase()
    ) ?? false;

  return !!hasPermission;
};

export const hasModulePermission = ModulePermission;
